import {
  DISCOVERY_WALL_ACTIONS_KEYS,
  DISCOVERY_WALL_GETTERS_KEYS,
  DISCOVERY_WALL_MUTATIONS_KEYS
} from '../discovery-wall/discovery-wall.const';
import {
  RECOMMENDATIONS_ACTIONS_KEYS,
  RECOMMENDATIONS_GETTERS_KEYS,
  RECOMMENDATIONS_MUTATIONS_KEYS
} from '../recommendations/recommendations.const';

export const EMPTY_SEARCH_MUTATIONS_KEYS = {
  ...RECOMMENDATIONS_MUTATIONS_KEYS,
  ...DISCOVERY_WALL_MUTATIONS_KEYS,
} as const;

export const EMPTY_SEARCH_ACTIONS_KEYS = {
  ...RECOMMENDATIONS_ACTIONS_KEYS,
  ...DISCOVERY_WALL_ACTIONS_KEYS,
} as const;

export const EMPTY_SEARCH_GETTERS_KEYS = {
  ...RECOMMENDATIONS_GETTERS_KEYS,
  ...DISCOVERY_WALL_GETTERS_KEYS,
} as const;
